import b, { useState as L, useMemo as H, useLayoutEffect as T } from "react";
import { o as O, f as k, s as D, b as I, u as G, a as B, c as F, d as K, e as $ } from "./floating-ui.react-87bo4V3_.js";
import { w as W } from "./windowControlsClearance-BonpJzP6.js";
import { jsxs as m, jsx as h } from "react/jsx-runtime";
const X = 20, j = 50, z = 200, U = 8, se = 200, Q = 2, x = 40, Y = 3;
function oe(n) {
  return typeof n != "number" || !Number.isFinite(n) ? X : Math.min(Math.max(Math.floor(n), 1), j);
}
function ae(n) {
  return n.startsWith("tracker-content/") ? { kind: "typed", id: n.slice(16) } : n.startsWith("type-page:") ? { kind: "typePage", id: n.slice(10) } : { kind: "page", id: n };
}
function q(n) {
  return n.normalize("NFKD").replace(/\p{M}/gu, "").toLowerCase();
}
function E(n) {
  let r = "";
  const s = [];
  let t = 0;
  for (const a of n) {
    const l = q(a);
    for (let i = 0; i < l.length; i++) s.push(t);
    r += l, t += a.length;
  }
  return s.push(t), { folded: r, map: s };
}
const _ = /[\p{L}\p{N}]+/gu;
function J(n) {
  const r = [];
  for (const s of E(n).folded.matchAll(_)) {
    const t = s[0];
    t.length >= Q && r.push(t.slice(0, x));
  }
  return r;
}
function ie(n) {
  const r = n.slice(0, z), s = [...new Set(J(r))].slice(0, U), t = s[s.length - 1], a = !!t && !/[^\p{L}\p{N}]$/u.test(r) && t.length >= Y;
  return { terms: s, prefixLast: a };
}
function V(n, r) {
  if (r.terms.length === 0) return [];
  const { folded: s, map: t } = E(n), a = [];
  for (const l of s.matchAll(_)) {
    const i = l[0], d = l.index ?? 0;
    r.terms.forEach((c, u) => {
      const e = u === r.terms.length - 1 && r.prefixLast, o = i.slice(0, x);
      if (e ? !o.startsWith(c) : o !== c) return;
      const f = d + (e ? c.length : i.length);
      a.push({ start: t[d], end: t[f], term: u });
    });
  }
  return a;
}
function le(n, r) {
  return r.terms.length === 0 ? !1 : new Set(V(n, r).map((t) => t.term)).size === r.terms.length;
}
const ce = 5;
function de(n, r, s = "team", t) {
  const a = (e) => (e.sharing ?? "personal") === "team" == (s === "team"), l = (e) => {
    const o = n.get(e);
    return o && a(o) ? o : void 0;
  }, i = (e) => n.get(e) ? null : t?.get(e) ?? null, d = (e) => !!l(e) || i(e) !== null, c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
  for (const e of r) {
    if (e.archived || s === "team" && e.localOnly) continue;
    const o = c.get(e.typeId) ?? [];
    o.push({ itemId: e.id, title: e.title, sortKey: e.issueNumber ?? e.title }), c.set(e.typeId, o), u.set(e.id, { itemId: e.id, title: e.title, typeId: e.typeId });
  }
  for (const e of c.values())
    e.sort((o, f) => typeof o.sortKey == "number" && typeof f.sortKey == "number" ? o.sortKey - f.sortKey : String(o.sortKey).localeCompare(String(f.sortKey), void 0, { numeric: !0 }));
  return {
    typeName: (e) => {
      const o = l(e);
      return o ? o.displayNamePlural || o.displayName || e : i(e) !== null ? e : null;
    },
    typeLabel: (e) => {
      const o = l(e);
      return o ? o.displayName || e : i(e) !== null ? e : null;
    },
    typeError: i,
    typeExtends: (e) => n.get(e)?.extends ?? null,
    // A placed typed page from the other lane is unknown here, like its type.
    item: (e) => {
      const o = u.get(e);
      return o && d(o.typeId) ? o : null;
    },
    itemsOfType: (e) => d(e) ? c.get(e) ?? [] : [],
    listedTypes: () => n.getListed().filter(a).map((e) => ({
      typeId: e.type,
      name: e.displayNamePlural || e.displayName || e.type,
      icon: e.icon,
      ...e.creatable === !1 ? { creatable: !1 } : {}
    }))
  };
}
const Z = [
  {
    name: "status",
    type: "select",
    options: [
      { value: "draft", label: "Draft", icon: "edit_note", color: "#64748b" },
      { value: "current", label: "Current", icon: "check_circle", color: "#22c55e" },
      { value: "outdated", label: "Outdated", icon: "history_toggle_off", color: "#f59e0b" }
    ]
  },
  { name: "owner", type: "user" },
  { name: "summary", type: "string", maxLength: 280 },
  { name: "tags", type: "array", itemType: "string" }
], ue = Z.filter((n) => n.type !== "array"), fe = (n, r, s = "Delete") => import("./ConfirmModal-CGBrB7ux.js").then((t) => t.openConfirm(n, r, s));
function pe(n, r) {
  return {
    getBoundingClientRect: () => DOMRect.fromRect({ x: n, y: r, width: 0, height: 0 })
  };
}
function me(n = {}) {
  const {
    placement: r = "bottom-start",
    offsetPx: s = 4,
    viewportPadding: t = 8,
    strategy: a = "fixed",
    constrainHeight: l = !0,
    reference: i = null,
    open: d,
    onOpenChange: c,
    dismiss: u
  } = n, [e, o] = L(!1), f = d ?? e, g = d === void 0 ? o : c ?? (() => {
  }), w = H(() => {
    const y = [
      O(s),
      k({ padding: t }),
      D({ padding: t }),
      W()
    ];
    return l && y.push(I({
      padding: t,
      apply({ availableHeight: R, elements: C, middlewareData: N }) {
        const P = N.windowControlsClearance?.pushed ?? 0;
        C.floating.style.maxHeight = `${Math.max(0, R - P)}px`;
      }
    })), y;
  }, [l, s, t]), p = G({
    open: f,
    onOpenChange: g,
    placement: r,
    strategy: a,
    middleware: w,
    whileElementsMounted: B
  });
  T(() => {
    i && p.refs.setPositionReference(i);
  }, [p.refs, i]);
  const v = F(p.context, u), A = K(p.context, { role: "menu" }), { getReferenceProps: S, getFloatingProps: M } = $([v, A]);
  return {
    isOpen: f,
    setIsOpen: g,
    refs: p.refs,
    floatingStyles: p.floatingStyles,
    getReferenceProps: S,
    getFloatingProps: M,
    context: p.context
  };
}
function he({
  breadcrumb: n,
  actions: r,
  className: s,
  testId: t
}) {
  return /* @__PURE__ */ m(
    "header",
    {
      className: `unified-editor-header-bar flex h-9 min-h-9 shrink-0 items-center justify-between gap-3 border-b border-nim bg-nim px-3 ${s ?? ""}`,
      "data-testid": t,
      children: [
        n,
        r ? (
          // A sibling of the breadcrumb rather than a trailing crumb: the crumbs
          // ellipsize under pressure and the actions must not be what gets clipped.
          /* @__PURE__ */ h("div", { className: "unified-header-actions flex shrink-0 items-center gap-1", children: r })
        ) : null
      ]
    }
  );
}
function ge({
  crumbs: n,
  leading: r,
  className: s
}) {
  return /* @__PURE__ */ m(
    "nav",
    {
      className: `unified-header-breadcrumb flex min-w-0 flex-1 items-center gap-1.5 overflow-hidden whitespace-nowrap text-[13px] text-nim-muted ${s ?? ""}`,
      "aria-label": "Breadcrumb",
      children: [
        r,
        n.map((t, a) => /* @__PURE__ */ m(b.Fragment, { children: [
          a > 0 ? /* @__PURE__ */ h("span", { className: "breadcrumb-separator shrink-0 text-[11px] text-nim-faint", "aria-hidden": "true", children: "/" }) : null,
          t.onClick ? /* @__PURE__ */ m(
            "button",
            {
              type: "button",
              className: "breadcrumb-segment breadcrumb-clickable -mx-1 -my-0.5 flex min-w-0 cursor-pointer items-center gap-1 overflow-hidden rounded border-none bg-transparent px-1 py-0.5 text-inherit transition-colors duration-150 hover:bg-nim-hover hover:text-nim",
              onClick: t.onClick,
              title: t.title ?? t.label,
              children: [
                t.icon,
                /* @__PURE__ */ h("span", { className: "min-w-0 overflow-hidden text-ellipsis", children: t.label })
              ]
            }
          ) : /* @__PURE__ */ m(
            "span",
            {
              className: `breadcrumb-segment flex min-w-0 items-center gap-1 overflow-hidden ${t.current ? "breadcrumb-current font-semibold text-nim" : ""}`,
              title: t.title ?? t.label,
              "aria-current": t.current ? "page" : void 0,
              children: [
                t.icon,
                /* @__PURE__ */ h("span", { className: "min-w-0 overflow-hidden text-ellipsis", children: t.label })
              ]
            }
          )
        ] }, t.id))
      ]
    }
  );
}
const ye = b.forwardRef(function({ label: r, onClick: s, active: t, haspopup: a, disabled: l, className: i, testId: d, children: c, ...u }, e) {
  return /* @__PURE__ */ h(
    "button",
    {
      ...u,
      ref: e,
      type: "button",
      disabled: l,
      onClick: s,
      title: r,
      "aria-label": r,
      "aria-haspopup": a ? "menu" : void 0,
      "aria-expanded": a ? !!t : void 0,
      "aria-pressed": !a && t !== void 0 ? t : void 0,
      "data-testid": d,
      className: `unified-header-button flex size-7 shrink-0 cursor-pointer items-center justify-center rounded border-none bg-transparent text-nim-muted transition-colors duration-150 hover:bg-nim-hover hover:text-nim disabled:cursor-default disabled:opacity-40 disabled:hover:bg-transparent ${t ? "bg-nim-tertiary text-nim" : ""} ${i ?? ""}`,
      children: c
    }
  );
});
export {
  he as E,
  ye as H,
  ue as P,
  ge as a,
  de as b,
  fe as c,
  j as d,
  se as e,
  ie as f,
  le as g,
  ce as h,
  ae as i,
  Z as j,
  oe as p,
  me as u,
  pe as v
};
//# sourceMappingURL=EditorHeaderBar-H6fYofbz.js.map
